<clr-main-container class="main-container" [class.dark-theme]="theme == 'dark'">
  <div id="overlay" [hidden]="!showoverlay">
    <ng-container #overlay />
  </div>
  <div id="main" class="d-f col">
    @if (isImageUrl) {
      @if (images?.length) {
        <app-image-slide-show [data]="images" height="100svh" />
      }

      @if (showpdf) {
        <div class="padding-15-t padding-15-lr h-100">
          <div class="clr-row h-100">
            <div class="clr-col-12">
              <div class="text-left inline-block">
                <h4 class="mt-0">{{ 'Inspektionsbericht' | mrTranslate }}</h4>
              </div>
              <div class="inline-block float-right">
                <a [attr.href]="pdf_url" [attr.download]="filename">
                  <button class="btn btn-primary btn-sm">
                    <cds-icon shape="download" />
                    {{ 'Download' | mrTranslate }}
                  </button>
                </a>
              </div>
            </div>
            <div class="clr-col-12 nxp" style="height: calc(100vh - 51px)">
              <iframe [attr.src]="pdf_url" style="border: none; width: 100%; height: 100%"></iframe>
            </div>
          </div>
        </div>
      }
    } @else {
      @if (alerts.length > 0) {
        <clr-alert [clrAlertType]="alerttyp" [clrAlertAppLevel]="true">
          <clr-alert-item>
            <span class="alert-text" style="white-space: pre-line">
              {{ alerttext | mrTranslate }}
            </span>
            <div class="alert-actions">
              <button class="btn alert-action" (click)="onCloseAlert(1)">
                {{ alertbutton }}
              </button>
            </div>
          </clr-alert-item>
        </clr-alert>
      }

      @if ((authservice.loggedin | async) === true) {
        <clr-header class="header-1">
          <div class="branding" style="flex: 0">
            <img src="{{ logo }}" class="mw-100-p light" />
            <img src="{{ logoDark }}" class="mw-100-p dark" />
          </div>
          @defer {
            <div class="header-nav" [clr-nav-level]="1">
              @if (allowComponents.dashboard && user.status > 2 && !isRep) {
                <a
                  [routerLink]="isFatUiLimited ? null : ['/dashboard']"
                  routerLinkActive="active"
                  class="nav-link"
                  [class.nav-disabled]="isFatUiLimited"
                  [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                  [attr.tabindex]="isFatUiLimited ? -1 : null"
                  (click)="blockDisabledNav($event)"
                  [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                  data-test-id="nav-dashboard">
                  <span class="nav-text">{{ 'Dashboard' | mrTranslate }}</span>
                </a>
              }
              @if (allowComponents.map || isRep) {
                <a
                  [routerLink]="isFatUiLimited ? null : ['/karte']"
                  routerLinkActive="active"
                  class="nav-link"
                  [class.nav-disabled]="isFatUiLimited"
                  [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                  [attr.tabindex]="isFatUiLimited ? -1 : null"
                  (click)="blockDisabledNav($event)"
                  [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                  data-test-id="nav-karte">
                  <span class="nav-text">{{ 'GIS Map' | mrTranslate }}</span>
                </a>
              }
               @if (allowComponents.anlagen) {
                <a [routerLink]="['/anlagen']" routerLinkActive="active" class="nav-link" data-test-id="nav-anlagen">
                  <span class="nav-text">{{ 'Anlagen' | mrTranslate }}</span>
                </a>
               }

              @if (allowComponents.maengel && !isRep) {
                <a
                  [routerLink]="isFatUiLimited ? null : ['/maengel']"
                  routerLinkActive="active"
                  class="nav-link"
                  [class.nav-disabled]="isFatUiLimited"
                  [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                  [attr.tabindex]="isFatUiLimited ? -1 : null"
                  (click)="blockDisabledNav($event)"
                  [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                  data-test-id="nav-maengel">
                  <span class="nav-text">{{ 'Mängel' | mrTranslate }}</span>
                </a>
              }
              @if (allowComponents.kalender && !isRep) {
                <a
                  [routerLink]="isFatUiLimited ? null : ['/pruefkalender']"
                  routerLinkActive="active"
                  class="nav-link"
                  [class.nav-disabled]="isFatUiLimited"
                  [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                  [attr.tabindex]="isFatUiLimited ? -1 : null"
                  (click)="blockDisabledNav($event)"
                  [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                  data-test-id="nav-pruefkalender">
                  <span class="nav-text">{{ 'Prüfkalender' | mrTranslate }}</span>
                </a>
              }
              @if (allowComponents.auftraege) {
                  <a
                    [routerLink]="isFatUiLimited ? null : ['/auftraege']"
                    routerLinkActive="active"
                    class="nav-link"
                    [class.nav-disabled]="isFatUiLimited"
                    [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                    [attr.tabindex]="isFatUiLimited ? -1 : null"
                    (click)="blockDisabledNav($event)"
                    [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                    data-test-id="nav-auftraege">
                    <span class="nav-text">{{ 'Aufträge' | mrTranslate }}</span>
                  </a>
              }
              @if (allowComponents.begehung) {
                <a
                  [routerLink]="isFatUiLimited ? null : ['/begehung']"
                  routerLinkActive="active"
                  class="nav-link"
                  [class.nav-disabled]="isFatUiLimited"
                  [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                  [attr.tabindex]="isFatUiLimited ? -1 : null"
                  (click)="blockDisabledNav($event)"
                  [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                  data-test-id="nav-begehungen">
                  <span class="nav-text">{{ 'Begehung' | mrTranslate }}</span>
                </a>
              }
              @if (user.status > 2 && allowComponents.wartung) {
                <a
                  [routerLink]="isFatUiLimited ? null : ['/wartung']"
                  routerLinkActive="active"
                  class="nav-link"
                  [class.nav-disabled]="isFatUiLimited"
                  [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                  [attr.tabindex]="isFatUiLimited ? -1 : null"
                  (click)="blockDisabledNav($event)"
                  [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                  data-test-id="nav-wartungen">
                  <span class="nav-text">{{ 'Wartung' | mrTranslate }}</span>
                </a>
              }
              @if (!isRep && allowComponents.projekt) {
                <a
                  [routerLink]="isFatUiLimited ? null : ['/projekt']"
                  routerLinkActive="active"
                  class="nav-link"
                  [class.nav-disabled]="isFatUiLimited"
                  [attr.aria-disabled]="isFatUiLimited ? 'true' : null"
                  [attr.tabindex]="isFatUiLimited ? -1 : null"
                  (click)="blockDisabledNav($event)"
                  [attr.title]="isFatUiLimited ? ('Nur Anlagen verfügbar (FAT‑Kontext)' | mrTranslate) : null"
                  data-test-id="nav-projekte">
                  <span class="nav-text">{{ 'Projekte' | mrTranslate }}</span>
                </a>
              }
            </div>
          }
          <div class="header-actions">
            @if (spinneractive) {
              <span class="clr-align-self-center margin-10-r">
                <clr-spinner clrMedium clrInverse />
              </span>
            }
            @if (trialMode) {
              <div id="trialInfoWrapper">
                <span>{{ 'Trial aktiv' | mrTranslate }}</span>
                @if (trialDate) {
                  <clr-tooltip style="padding-top: 1.3em; margin-right: 1em; margin-left: 0.3em">
                    <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="Uniq tooltip 3" />
                    <clr-tooltip-content *clrIfOpen clrPosition="bottom-right" clrSize="md">
                      <span>
                        {{ 'Der Testmodus ist gültig bis' | mrTranslate }}:
                        <br />
                        {{ trialDate | date: 'medium' }}
                      </span>
                      <br />
                      <span>
                        {{ 'Im Trial Modus sind alle Daten manipulierenden Aktion gesperrt.' | mrTranslate }}
                      </span>
                    </clr-tooltip-content>
                  </clr-tooltip>
                }
              </div>
            }
            @if (!isRep) {
              <clr-dropdown id="PropertiesDropdown">
                <button
                  clrDropdownTrigger
                  class="nav-link nav-icon cursor-pointer"
                  title="{{ 'Einstellungen' | mrTranslate }}"
                  data-test-id="main-menu-button">
                  <cds-icon size="22" shape="ellipsis-horizontal" />
                </button>
                <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
                  @if (allowComponents.statistic) {
                    <a
                      clrDropdownItem
                      (click)="!isFatUiLimited && openStatistik()"
                      [class.disabled-menu-item]="isFatUiLimited"
                      [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                      <cds-icon size="22" shape="bar-chart" />
                      <span>{{ 'Statistik' | mrTranslate }}</span>
                    </a>
                  }
                  @if (authservice.token.rights.status >= 3) {
                    <a
                      clrDropdownItem
                      (click)="!isFatUiLimited && openAddressbook()"
                      [class.disabled-menu-item]="isFatUiLimited"
                      [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                      <cds-icon size="22" shape="book" />
                      <span>{{ 'Adressen verwalten' | mrTranslate }}</span>
                    </a>
                  }
                  @if (authservice.token.rights.showusers == true) {
                    <a
                      clrDropdownItem
                      (click)="!isFatUiLimited && openUserManagement()"
                      [class.disabled-menu-item]="isFatUiLimited"
                      [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                      <cds-icon size="22" shape="users" />
                      <span>{{ 'Benutzer verwalten' | mrTranslate }}</span>
                    </a>
                  }
                  @if (
                    authservice.token.rights.status == 6 ||
                    authservice.token.rights.admin == true ||
                    authservice.token.rights.dev == true
                  ) {
                    <a
                      clrDropdownItem
                      (click)="!isFatUiLimited && isBerichteModalOpen.set(true)"
                      [class.disabled-menu-item]="isFatUiLimited"
                      [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                      <cds-icon size="22" shape="envelope" />
                      <span>{{ 'Berichte verwalten' | mrTranslate }}</span>
                    </a>
                  }
                  @if (
                    !isFatUiLimited &&
                    (authservice.token.rights.status == 6 ||
                      authservice.token.rights.admin == true ||
                      authservice.token.rights.dev == true)
                  ) {
                    <clr-dropdown>
                      <a clrDropdownTrigger>
                        <cds-icon size="22" shape="container-volume" />
                        <span>{{ 'Datenbank' | mrTranslate }}</span>
                      </a>
                      <clr-dropdown-menu clrPosition="bottom-right" *clrIfOpen>
                        <a clrDropdownItem (click)="openObjekttypManagement()">
                          <cds-icon size="23" shape="objecttypen" />
                          <span>{{ 'Objektverwaltung' | mrTranslate }}</span>
                        </a>
                        <a clrDropdownItem (click)="openBauformVerwaltung()">
                          <cds-icon size="22" shape="grid-view" />
                          <span>{{ 'Bauformverwaltung' | mrTranslate }}</span>
                        </a>
                        <a clrDropdownItem (click)="openLinienverwaltungDialogComponent()">
                          <cds-icon size="22" shape="switch" />
                          <span>{{ 'Linienverwaltung' | mrTranslate }}</span>
                        </a>
                        <a clrDropdownItem (click)="openWartungsVerwaltung()">
                          <cds-icon size="22" shape="wartung" />
                          <span>{{ 'Wartungsverwaltung' | mrTranslate }}</span>
                        </a>
                        <a clrDropdownItem (click)="openBegehungsVerwaltung()">
                          <cds-icon size="18" shape="clock" />
                          <span>{{ 'Begehungsverwaltung' | mrTranslate }}</span>
                        </a>
                        <a clrDropdownItem (click)="openPruefungenverwaltenDialog()">
                          <cds-icon size="24" shape="check-circle" />
                          <span>{{ 'Prüfungsverwaltung' | mrTranslate }}</span>
                        </a>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                  }
                  @if (
                    authservice.token.rights.status == 6 ||
                    authservice.token.rights.admin == true ||
                    authservice.token.rights.dev == true
                  ) {
                    <div class="showSettings">
                      <div class="dropdown-divider" role="separator"></div>
                      <a clrDropdownItem (click)="dosettingsModalOpen()">
                        <cds-icon size="22" shape="cog" />
                        <span>{{ 'Einstellungen' | mrTranslate }}</span>
                      </a>
                      <a
                        clrDropdownItem
                        (click)="!isFatUiLimited && openSystemManagement()"
                        [class.disabled-menu-item]="isFatUiLimited"
                        [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                        <cds-icon size="22" shape="tools" />
                        <span>{{ 'Systemverwaltung' | mrTranslate }}</span>
                      </a>
                    </div>
                  }
                  <clr-dropdown>
                    <a clrDropdownTrigger>
                      <cds-icon size="22" shape="help" />
                      <span>{{ 'Hilfe' | mrTranslate }}</span>
                    </a>
                    <clr-dropdown-menu clrPosition="bottom-right" *clrIfOpen>
                      @if (lang == 'de') {
                        <a
                          clrDropdownItem
                          href="https://www.bahnwege-seminare.de/mrpro/Cloud/DE/Hilfe.html"
                          target="_blank">
                          <cds-icon size="22" shape="help" />
                          <span>{{ 'Hilfe' | mrTranslate }}</span>
                        </a>
                        <a
                          clrDropdownItem
                          href="http://www.bahnwege-seminare.de/mrpro/ReleaseCloud/DE/Titel.html"
                          target="_blank">
                          <cds-icon size="22" shape="new" />
                          <span>{{ 'Release Note' | mrTranslate }}</span>
                        </a>
                        <a
                          clrDropdownItem
                          href="https://mr-pro.atlassian.net/servicedesk/customer/portal/3"
                          target="_blank">
                          <cds-icon size="22" shape="jira_support" />
                          <span>{{ 'Support Center' | mrTranslate }}</span>
                        </a>
                      } @else {
                        <a
                          clrDropdownItem
                          href="https://www.bahnwege-seminare.de/mrpro/Cloud/EN/MRprohelp.html"
                          target="_blank">
                          <cds-icon size="22" shape="help" />
                          <span>{{ 'Hilfe' | mrTranslate }}</span>
                        </a>
                        <a
                          clrDropdownItem
                          href="http://www.bahnwege-seminare.de/mrpro/ReleaseCloud/DE/Titel.html"
                          target="_blank">
                          <cds-icon size="22" shape="new" />
                          <span>{{ 'Release Note' | mrTranslate }}</span>
                        </a>
                        <a
                          clrDropdownItem
                          href="https://mr-pro.atlassian.net/servicedesk/customer/portal/3"
                          target="_blank">
                          <cds-icon size="22" shape="jira_support" />
                          <span>{{ 'Support Center' | mrTranslate }}</span>
                        </a>
                      }
                      <div class="dropdown-divider" role="separator"></div>
                      <a clrDropdownItem href="https://mr-pro.de/de/datenschutz.html" target="_blank">
                        <cds-icon size="22" shape="lock" />
                        <span>{{ 'Datenschutz' | mrTranslate }}</span>
                      </a>
                      <a clrDropdownItem href="https://mr-pro.de/de/impressum.html" target="_blank">
                        <cds-icon size="22" shape="help-info" />
                        <span>{{ 'Impressum' | mrTranslate }}</span>
                      </a>
                      <a clrDropdownItem (click)="showInfoBox = true">
                        <cds-icon size="22" shape="info-standard" />
                        <span>{{ 'Info' | mrTranslate }}</span>
                      </a>
                      <div class="dropdown-divider" role="separator"></div>
                      @if (versionInfo) {
                        <label style="font-weight: bold" clrDropdownItem (click)="copyToClipboard()">
                          {{ versionInfo }}
                        </label>
                      }
                    </clr-dropdown-menu>
                  </clr-dropdown>
                  @if (canSeeWerksabnahmeTemplates()) {
                    <div class="dropdown-divider" role="separator"></div>
                    <a clrDropdownItem (click)="openFormcreation()" data-test-id="menu-werksabnahme-vorlagen-erstellen">
                      <cds-icon size="22" shape="form" />
                      <span>{{ 'Vorlagen für Werksabnahme erstellen' | mrTranslate }}</span>
                    </a>
                  }
                  @if (allowComponents.messung) {
                    @if (
                      authservice.token.rights.status >= 3 ||
                      authservice.token.rights.admin == true ||
                      authservice.token.rights.dev == true
                    ) {
                      <clr-dropdown [class.disabled-menu-item]="isFatUiLimited">
                        <div class="dropdown-divider" role="separator"></div>
                        <button
                          clrDropdownTrigger
                          type="button"
                          class="dropdown-trigger-btn"
                          (click)="isFatUiLimited && blockDisabledNav($event)"
                          [disabled]="isFatUiLimited"
                          [class.disabled-menu-item]="isFatUiLimited"
                          [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                          <cds-icon size="22" shape="upload-cloud" />
                          <span>{{ 'Messdaten hochladen' | mrTranslate }}</span>
                        </button>
                        <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
                          <a
                            clrDropdownItem
                            (click)="!isFatUiLimited && isWeichenMessImport.set(true)"
                            [class.disabled-menu-item]="isFatUiLimited"
                            [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                            <cds-icon size="22" shape="chartswitch" />
                            <span>{{ 'Weichenmessung' | mrTranslate }}</span>
                          </a>
                          <a
                            clrDropdownItem
                            (click)="!isFatUiLimited && openMessungModal()"
                            [class.disabled-menu-item]="isFatUiLimited"
                            [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                            <cds-icon size="22" shape="line-chart" />
                            <span>{{ 'Streckenmessdaten' | mrTranslate }}</span>
                          </a>
                        </clr-dropdown-menu>
                      </clr-dropdown>
                      <clr-dropdown [class.disabled-menu-item]="isFatUiLimited">
                        <button
                          clrDropdownTrigger
                          type="button"
                          class="dropdown-trigger-btn"
                          (click)="isFatUiLimited && blockDisabledNav($event)"
                          [disabled]="isFatUiLimited"
                          [class.disabled-menu-item]="isFatUiLimited"
                          [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                          <cds-icon size="22" shape="align-bottom" />
                          <span>{{ 'Messdaten auswerten' | mrTranslate }}</span>
                        </button>
                        <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
                          <a
                            clrDropdownItem
                            (click)="!isFatUiLimited && openMessregAuswertungModal()"
                            [class.disabled-menu-item]="isFatUiLimited"
                            [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                            <cds-icon size="22" shape="excel" />
                            <span>{{ 'Messung nach Excel expotieren' | mrTranslate }}</span>
                          </a>
                          <a
                            clrDropdownItem
                            (click)="!isFatUiLimited && openGleisToleranzAusfallBerechnung()"
                            [class.disabled-menu-item]="isFatUiLimited"
                            [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                            <cds-icon size="22" shape="line-chart" />
                            <span>
                              {{ 'Gleis' | mrTranslate }} - {{ 'Toleranzverletzungen berechnen' | mrTranslate }}
                            </span>
                          </a>
                        </clr-dropdown-menu>
                      </clr-dropdown>
                    }
                  }
                  <div class="dropdown-divider" role="separator"></div>
                  <a
                    clrDropdownItem
                    (click)="!isFatUiLimited && openSonderinspektionsListedialog()"
                    [class.disabled-menu-item]="isFatUiLimited"
                    [attr.aria-disabled]="isFatUiLimited ? 'true' : null">
                    <cds-icon size="22" shape="warning-standard" />
                    <span>{{ 'Sonderinspektion anzeigen' | mrTranslate }}</span>
                  </a>
                </clr-dropdown-menu>
              </clr-dropdown>
            }
            <clr-dropdown>
              @if (user != null) {
                @if (user.image) {
                  <button
                    clrDropdownTrigger
                    class="nav-link nav-icon cursor-pointer"
                    title="{{ user.vorname + ' ' + user.nachname }}"
                    data-test-id="user-menu-button">
                    <img
                      class="useravatar"
                      [src]="getImageSaveUrl(user.image)"
                      alt="avatar"
                      id="avatar"
                      style="display: block" />
                  </button>
                } @else {
                  <button
                    clrDropdownTrigger
                    class="nav-link nav-icon cursor-pointer"
                    title="{{ user.vorname + ' ' + user.nachname }}"
                    data-test-id="user-menu-button">
                    <img class="useravatar" [src]="getSVGImageUrl(user.svg)" alt="avatar" id="avatar" />
                  </button>
                }
              } @else {
                <!-- Sollte der User fehlen (z.B. durch fehlerhaften Token), wird hier ein Icon fürs Logout angezeigt -->
                <button
                  clrDropdownTrigger
                  class="nav-link nav-icon cursor-pointer"
                  (click)="logout()"
                  data-test-id="user-menu-button">
                  <img class="useravatar" src="{{ exitAvatar }}" style="display: block" />
                </button>
              }
              <clr-dropdown-menu clrPosition="bottom-right" *clrIfOpen>
                <label style="font-weight: bold" clrDropdownItem>{{ DBName }}</label>
                <a clrDropdownItem (click)="toggleTheme()">
                  {{ 'Farbschema wechseln' | mrTranslate | titlecase }}
                </a>
                <a clrDropdownItem (click)="dosettingsModalOpen()" data-test-id="user-menu-settings">
                  {{ 'Einstellungen' | mrTranslate | titlecase }}
                </a>
                <a clrDropdownItem (click)="changePasswordClick()">
                  {{ 'Passwort ändern' | mrTranslate | titlecase }}
                </a>
                <clr-dropdown>
                  <button clrDropdownTrigger>
                    {{ 'Sprache wechseln' | mrTranslate | titlecase }}
                  </button>
                  <clr-dropdown-menu clrPosition="bottom-right" *clrIfOpen>
                    <clr-dropdown>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('de')">
                        <img src="assets/flags/de.svg" class="flag" />
                        deutsch
                      </a>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('en')">
                        <img src="assets/flags/en.svg" class="flag" />
                        english
                      </a>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('fr')">
                        <img src="assets/flags/fr.svg" class="flag" />
                        français
                      </a>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('it')">
                        <img src="assets/flags/it.svg" class="flag" />
                        italiano
                      </a>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('nl')">
                        <img src="assets/flags/nl.svg" class="flag" />
                        nederlands
                      </a>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('pt')">
                        <img src="assets/flags/pt.svg" class="flag" />
                        português
                      </a>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('ru')">
                        <img src="assets/flags/ru.svg" class="flag" />
                        русский
                      </a>
                      <a clrDropdownItem href="javascript:void(0);" (click)="changeLanguage('tr')">
                        <img src="assets/flags/tr.svg" class="flag" />
                        türkçe
                      </a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                @if (isRep) {
                  <div class="dropdown-divider" role="separator"></div>
                  <a clrDropdownItem (click)="clearReplikat()">
                    {{ 'Replikat löschen' | mrTranslate | titlecase }}
                  </a>
                }
                <div class="dropdown-divider" role="separator"></div>
                <a clrDropdownItem (click)="logout()" data-test-id="user-menu-logout">
                  {{ 'Abmelden' | mrTranslate | titlecase }}
                </a>
              </clr-dropdown-menu>
            </clr-dropdown>
          </div>
        </clr-header>
      }
      <div class="content-container" [hidden]="showoverlay">
        <div id="content-area" class="content-area">
          @if (user) {
            <app-einstellungsmodal />
          }
          @if (isWeichenMessImport()) {
            <app-weichen-mess-import [(isOpen)]="isWeichenMessImport" (reload)="reload()" />
          }
          @if (isMessungModalOpen) {
            <app-strecken-mess-import />
          }
          @if (isGrenzwertModalOpen) {
            <app-gleisgrenzwertverletzung />
          }
          @if (isMessregAuswertungModalOpen) {
            <app-messregauswertungmodal />
          }
          @if (isBerichteModalOpen()) {
            <app-berichte-config-modal [(isOpen)]="isBerichteModalOpen" />
          }

          <div class="app-wrapper">
            <router-outlet />
          </div>
        </div>
      </div>
    }
  </div>
</clr-main-container>

<!-- MODAL PASSWORT ÄNDERN -->
@if (changePassword) {
  <clr-modal [(clrModalOpen)]="changePassword" [clrModalSize]="'sm'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Passwort ändern' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm [formGroup]="passwordGroup" clrLayout="vertical">
        <div class="clr-row">
          <div class="clr-col-11">
            <div class="clr-control-container" style="width: 200px">
              <clr-password-container>
                <input
                  clrPassword
                  placeholder="{{ 'aktuelles Passwort' | mrTranslate }}"
                  name="password"
                  formControlName="opw"
                  style="width: 200px" />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-password-container>
            </div>
            <div class="clr-control-container" style="width: 200px">
              <clr-password-container>
                <input
                  clrPassword
                  autocomplete="off"
                  placeholder="{{ 'neues Passwort' | mrTranslate }}"
                  name="password"
                  formControlName="npw"
                  style="width: 200px" />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-password-container>
            </div>
            <div class="clr-control-container" style="width: 200px">
              <clr-password-container>
                <input
                  clrPassword
                  autocomplete="off"
                  placeholder="{{ 'Passwort bestätigen' | mrTranslate }}"
                  name="password"
                  formControlName="npw1"
                  style="width: 200px" />
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-password-container>
            </div>
            <br />
          </div>
        </div>
        <div><br /></div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="setNewPassword($event)">
        {{ 'OK' | mrTranslate }}
      </button>
      <button type="button" class="btn" (click)="changePassword = false">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}

<!-- MODAL INFOBOX -->
@if (showInfoBox) {
  <clr-modal [(clrModalOpen)]="showInfoBox" [clrModalSize]="'xl'" [clrModalClosable]="true">
    <h3 class="modal-title">{{ 'Info' | mrTranslate }}</h3>
    <div class="modal-body">
      <form clrForm clrLayout="vertical">
        <div class="clr-row">
          <div class="clr-col-4">
            <clr-textarea-container style="height: 60vh">
              <label>Info</label>
              <textarea clrTextarea style="height: 58vh; width: 20vw" readonly>
                {{ InfoBox }}
              </textarea>
            </clr-textarea-container>
          </div>
          <div class="clr-col-8">
            <clr-textarea-container>
              <label>EULA</label>
              <textarea clrTextarea style="height: 58vh; width: 38vw" readonly>
                {{ EULAdescription }}
              </textarea>
            </clr-textarea-container>
            <br />
          </div>
        </div>
        <div><br /></div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn" (click)="showInfoBox = false">
        {{ 'Schließen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}

@if (checkAdminPWShowModal) {
  <clr-modal [(clrModalOpen)]="checkAdminPWShowModal" [clrModalSize]="'md'" [clrModalClosable]="true">
    <h3 class="modal-title">
      {{ 'Anmeldung Benutzerverwaltung' | mrTranslate }}
    </h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" style="margin-top: -25px">
        <p>{{ 'Bitte geben Sie ihre Passwort ein.' | mrTranslate }}</p>
        <clr-password-container>
          <label>{{ 'Passwort' | mrTranslate }}</label>
          <input clrPassword autocomplete="off" name="password" style="width: 250px" #adminpw />
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
        </clr-password-container>
        <br />
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="checkAdminPW($event)">
        {{ 'OK' | mrTranslate }}
      </button>
      <button type="button" class="btn" (click)="checkAdminPWShowModal = false">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>
}

@if (googleCodeShow) {
  <clr-modal [(clrModalOpen)]="googleCodeShow" [clrModalSize]="'md'" [clrModalClosable]="true">
    <h3 class="modal-title">
      {{ '2‑Faktor-Authentifizierung mit Google Authenticator' | mrTranslate }}
    </h3>
    <div class="modal-body">
      <form clrForm clrLayout="horizontal">
        <div>
          {{ 'Geben Sie den 6-stelligen Code aus der Autenthicator App ein.' | mrTranslate }}
        </div>
        <div class="clr-input-wrapper" style="margin-top: 10px">
          <input
            clrInput
            placeholder="Code"
            id="excode"
            type="text"
            style="width: 200px"
            #input
            class="clr-input"
            (keyup.enter)="verifyGoogleCode()" />
        </div>
        <br />
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="verifyGoogleCode()">
        {{ 'Anmelden' | mrTranslate }}
      </button>
      <!-- <button type="button" class="btn" (click)="googleCodeShow = false">{{ "Abbrechen" | mrTranslate }}</button> -->
    </div>
  </clr-modal>
}

@if (openRepProgress.isRepProgressModalOpen()) {
  <app-replikat-progress
    [mode]="'setup'"
    [setupConfig]="openRepProgress.setupConfig()"
    [(modalOpen)]="openRepProgress.isRepProgressModalOpen" />
}

<app-beschreibung-dialog />
<app-confirm-dialog />
<!-- ! Important to be last -->
